// extracted by mini-css-extract-plugin
module.exports = {"slideOverride":"TimeSlotCarousel_slideOverride__zZaAz"};